import { PricingScheme } from '@libs/graphql/types'

export function getPricingSuffix(
  scheme?: PricingScheme | null,
  { compact = false }: { compact?: boolean } = {}
) {
  let suffix = ''

  switch (scheme) {
    case PricingScheme.DAILY:
    case PricingScheme.DAILY_TIERED:
      suffix = compact ? '/day' : '/ day'
      break
    case PricingScheme.PER_GUEST:
    case PricingScheme.TIERED:
      suffix = compact ? '/hr' : '/ hour'
      break
    default:
      suffix = ''
  }

  return suffix
}
